(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9960],{

/***/ 39960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ cart_CartItemTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 13 modules
var es = __webpack_require__(9473);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./public/icons/small-tooltip.svg
var small_tooltip = __webpack_require__(36023);
// EXTERNAL MODULE: ./components/core/ToolTip/ToolTip.jsx
var ToolTip = __webpack_require__(53683);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-number-format/dist/react-number-format.es.js
var react_number_format_es = __webpack_require__(57333);
// EXTERNAL MODULE: ./node_modules/html-react-parser/index.mjs
var html_react_parser = __webpack_require__(25935);
// EXTERNAL MODULE: ./store/features/cartSlice.js
var cartSlice = __webpack_require__(46201);
// EXTERNAL MODULE: ./utils/helper.js + 1 modules
var helper = __webpack_require__(55760);
// EXTERNAL MODULE: ./components/cart/CartItemTile/utils.js
var utils = __webpack_require__(54114);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./constants/index.js
var constants = __webpack_require__(96301);
// EXTERNAL MODULE: ./components/cart/cartAnalytics.js
var cartAnalytics = __webpack_require__(96514);
// EXTERNAL MODULE: ./components/cart/CartItemTile/analytics.js
var analytics = __webpack_require__(69162);
// EXTERNAL MODULE: ./components/cart/QuantitySelector.jsx
var QuantitySelector = __webpack_require__(75653);
// EXTERNAL MODULE: ./components/core/Radio/Radio.jsx
var Radio = __webpack_require__(20170);
// EXTERNAL MODULE: ./components/cart/cartHelper.js + 1 modules
var cartHelper = __webpack_require__(93284);
// EXTERNAL MODULE: ./hooks/useWindowResize.js
var useWindowResize = __webpack_require__(11859);
// EXTERNAL MODULE: ./components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(17169);
// EXTERNAL MODULE: ./public/icons/close.svg
var icons_close = __webpack_require__(653);
// EXTERNAL MODULE: ./public/icons/tooltip.svg
var tooltip = __webpack_require__(7033);
// EXTERNAL MODULE: ./components/core/SelectDropdown/SelectDropdown.jsx
var SelectDropdown = __webpack_require__(77860);
// EXTERNAL MODULE: ./utils/cart.js
var cart = __webpack_require__(11763);
;// CONCATENATED MODULE: ./components/cart/RecalculateModal/TrimCalculator.jsx







const PDPTrimCalculator = (props)=>{
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    const tempVal = props.templateType === "trim";
    const soldByBoxVal = props.soldByBox * props.soldByUom;
    const soldVal = !tempVal ? soldByBoxVal.toFixed(2) : props.soldByUom;
    const [linerLF, setLinerLF] = (0,react.useState)(props.totalNeeded ? props.totalNeeded : "");
    const [displayValSF, setDisplayValSF] = (0,react.useState)((props === null || props === void 0 ? void 0 : (ref = props.allAdditinalInfo) === null || ref === void 0 ? void 0 : ref.totalSFUserNeeded) ? props === null || props === void 0 ? void 0 : (ref1 = props.allAdditinalInfo) === null || ref1 === void 0 ? void 0 : ref1.totalSFUserNeeded : "");
    const [displayVal, setDisplayVal] = (0,react.useState)((props === null || props === void 0 ? void 0 : (ref2 = props.allAdditinalInfo) === null || ref2 === void 0 ? void 0 : ref2.totalUserNeeded) ? props === null || props === void 0 ? void 0 : (ref3 = props.allAdditinalInfo) === null || ref3 === void 0 ? void 0 : ref3.totalUserNeeded : "");
    const [overage, setOverage] = (0,react.useState)(props.overage ? props.overage : 15);
    const [customOverage, setCustomOverage] = (0,react.useState)("");
    const [totalOverage, setTotalOverage] = (0,react.useState)(0);
    const [totalLF, setTotalLF] = (0,react.useState)(0);
    const [pises, setPises] = (0,react.useState)(0);
    const [price, setPrice] = (0,react.useState)(0);
    const [addToCartButtonDisable, setAddToCartButtonDisable] = (0,react.useState)(true);
    const overageList = [
        0,
        5,
        10,
        15,
        20,
        "Custom"
    ];
    const [trimTooltip, setTrimTooltip] = (0,react.useState)({
        sqFeetTooltip: false,
        overageTooltip: false,
        totalCoverageTooltip: false
    });
    const trimCalculationMainBlockElementRef = (0,react.useRef)(null);
    const ftNeededTooltipStaticText = tempVal ? props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded;
    const [totalSoldValue, setTotalSoldValue] = (0,react.useState)(0);
    const [stockValue, setStockValue] = (0,react.useState)((props === null || props === void 0 ? void 0 : props.stockValue) ? props === null || props === void 0 ? void 0 : props.stockValue : 0);
    const [isUserInput, setIsUserInput] = (0,react.useState)(false);
    (0,react.useEffect)(()=>{
        var ref;
        const trimCalculatorTotalSqFt = Number(displayValSF) ? (ref = Number(displayValSF)) === null || ref === void 0 ? void 0 : ref.toFixed(3) : totalLF.toFixed(3);
        setDisplayVal((trimCalculatorTotalSqFt * 100 / (Number(overage) + 100)).toFixed(2));
    }, []);
    const onChangeHandler = (value)=>{
        var ref;
        setIsUserInput(true);
        if (!value) {
            setTotalLF(0);
            setTotalOverage(0);
            setPises(0);
            setPrice(0);
            localStorage.setItem("itemFinalPrice", 0);
            setDisplayVal("");
            setDisplayValSF("");
            setLinerLF("");
            return false;
        }
        if (value < 0) {
            document.getElementById("txt_prod_price").value = 0;
            setDisplayVal("");
            setDisplayValSF("");
            setLinerLF(0);
            return false;
        }
        const arr = value === null || value === void 0 ? void 0 : value.split(".");
        if ((value === null || value === void 0 ? void 0 : value.length) <= 5 || (arr === null || arr === void 0 ? void 0 : arr.length) <= 2 && ((ref = arr[1]) === null || ref === void 0 ? void 0 : ref.length) <= 2) {
            setDisplayVal("");
            setDisplayValSF("");
            setLinerLF(value);
        }
    };
    const trimTooltipHandler = (sqFeetTooltip, overageTooltip, totalCoverageTooltip, msg)=>{
        setTrimTooltip({
            sqFeetTooltip: sqFeetTooltip,
            overageTooltip: overageTooltip,
            totalCoverageTooltip: totalCoverageTooltip
        });
        (0,cartAnalytics/* addDatalayer */.au)({
            title: "info icon mouseover",
            section: "recalculate your space modal",
            tooltipVal: msg === null || msg === void 0 ? void 0 : msg.toLowerCase(),
            productInfo: props.productInfo
        });
    };
    const onChangeCustomOverage = (custVal)=>{
        if (custVal < 0) {
            document.getElementById("trim-calculator__overage-input-box").value = 0;
            setCustomOverage(0);
            return false;
        }
        const dot = custVal.split(".");
        if (dot.length === 2 || dot[0] === "") {
            setCustomOverage("");
        }
        if (dot.length !== 2 && dot[0] !== "" && custVal.length <= 2) {
            setCustomOverage(custVal);
        }
    };
    const onChangeOverage = function() {
        let value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, addDL = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, sqaureFeetSelection = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, customOverageSelection = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        var ref, ref1;
        let res = 0;
        setOverage(value);
        const tmpOverageVal = (value === null || value === void 0 ? void 0 : (ref = value.toLowerCase) === null || ref === void 0 ? void 0 : ref.call(value)) === "custom" ? customOverage : value;
        res = Number(linerLF) * Number(tmpOverageVal) / 100;
        const total = res + Number(linerLF);
        const pres = soldVal !== undefined && soldVal > 0 ? Math.ceil(total) * soldVal : 0;
        const boxPeice = soldVal !== undefined && soldVal > 0 ? props.soldByUom * Math.ceil(total) / props.soldByBox : 0;
        setPises(!tempVal ? Math.ceil(boxPeice) : Math.ceil(pres));
        const tempValPrice = !tempVal ? stockValue < Math.ceil(boxPeice) ? stockValue : Math.ceil(boxPeice) : stockValue < Math.ceil(pres) ? stockValue : Math.ceil(pres);
        const priceByBox = (props === null || props === void 0 ? void 0 : props.discountPrice) > 0 ? props.discountPrice : props.priceByBox;
        const validPriceByBox = priceByBox !== undefined;
        const isValid = validPriceByBox && priceByBox > 0;
        const finalPrice = isValid ? tempValPrice * priceByBox : 0;
        setPrice(finalPrice);
        localStorage.setItem("itemFinalPrice", finalPrice);
        const tOverage = soldVal !== undefined && soldVal > 0 ? stockValue < Math.ceil(pres) ? stockValue / soldVal : Math.ceil(pres) / soldVal : 0;
        const tileOverage = soldVal !== undefined && soldVal > 0 ? (props === null || props === void 0 ? void 0 : props.soldByBox) / (props === null || props === void 0 ? void 0 : props.soldByUom) * (stockValue < Math.ceil(boxPeice) ? stockValue : Math.ceil(boxPeice)) : 0;
        setTotalOverage(!tempVal ? tileOverage : tOverage);
        setTotalLF(Math.ceil(total));
        addDL && (0,cartAnalytics/* addDatalayer */.au)({
            title: "calculate footage",
            section: "recalculate your space modal",
            productInfo: props.productInfo,
            sqaureFeetSelection,
            calculated_Values: JSON.stringify({
                squareFeetNeeded: Number(linerLF),
                overage: customOverageSelection ? Number(customOverage) : (value === null || value === void 0 ? void 0 : (ref1 = value.toLowerCase) === null || ref1 === void 0 ? void 0 : ref1.call(value)) === "custom" ? "custom" : Number(value),
                totalSquareFeet: Number(Math.ceil(total).toFixed(3)),
                totalCoverage: Number((!tempVal ? tileOverage : tOverage).toFixed(3)),
                totalBoxes: Math.ceil(tempValPrice),
                totalPrice: Number(finalPrice.toFixed(3))
            })
        });
    };
    const onBlurHandler = function(value) {
        let addDL = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, sqaureFeetSelection = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, customOverageSelection = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
        const addToCartRef = document.querySelector(".add-to-cart__main-button");
        const stickyHeaderRef = document.querySelector(".sticky-header__main-button");
        if (addToCartRef) {
            if (Number(linerLF) && Number(pises) > 0 || Number(value) > 0) {
                var ref;
                addToCartRef.classList.remove("disabled");
                setAddToCartButtonDisable(false);
                stickyHeaderRef === null || stickyHeaderRef === void 0 ? void 0 : (ref = stickyHeaderRef.classList) === null || ref === void 0 ? void 0 : ref.remove("disabled");
            } else {
                var ref1;
                addToCartRef.classList.add("disabled");
                setAddToCartButtonDisable(true);
                stickyHeaderRef === null || stickyHeaderRef === void 0 ? void 0 : (ref1 = stickyHeaderRef.classList) === null || ref1 === void 0 ? void 0 : ref1.add("disabled");
            }
        }
        if (linerLF) {
            onChangeOverage(overage, addDL, sqaureFeetSelection, customOverageSelection);
        }
    };
    const onCustomOverageBlur = ()=>{
        onBlurHandler(linerLF, true, false, true);
    };
    (0,react.useEffect)(()=>{
        if (props.shwoInModal) {
            onBlurHandler(linerLF);
        }
    }, []);
    (0,react.useEffect)(()=>{
        trimCalculationMainBlockElementRef.current.classList.toggle("remove-while-print", addToCartButtonDisable);
    }, [
        addToCartButtonDisable
    ]);
    (0,react.useEffect)(()=>{
        const tmpTiletotalSoldValue = props.soldByBox / props.soldByUom;
        const tmpTrimtotalSoldValue = 1 / props.soldByUom;
        setTotalSoldValue(!tempVal ? tmpTiletotalSoldValue : tmpTrimtotalSoldValue);
    }, [
        props.soldByBox,
        props.soldByUom
    ]);
    const updateCartHandler = ()=>{
        props.updateRecalculateCarts();
        (0,cartAnalytics/* addDatalayer */.au)({
            title: "".concat(props.i18n.recalculateUpdateCart.toLowerCase()),
            section: "recalculate your space modal",
            productInfo: props.productInfo,
            calculated_Values: JSON.stringify({
                squareFeetNeeded: Number(linerLF),
                overage: Number(overage) || Number(customOverage),
                totalSquareFeet: Number(totalLF.toFixed(3)),
                totalCoverage: Number(totalOverage.toFixed(3)),
                totalBoxes: Math.ceil(pises),
                totalPrice: Number(price.toFixed(3))
            })
        });
    };
    (0,react.useEffect)(()=>{
        if (props === null || props === void 0 ? void 0 : props.sku) {
            (0,cart/* getStock */.K5)(props === null || props === void 0 ? void 0 : props.sku).then((param)=>{
                let { stock =0  } = param;
                if (stock) {
                    setStockValue(stock);
                }
            });
        }
    }, [
        pises
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        id: "trim-calculator_main-block",
        ref: trimCalculationMainBlockElementRef,
        className: "trimWrapper trim-calculator_main-block",
        totaloverage: totalOverage.toFixed(3),
        totalpeices: pises,
        soldbyuom: props.soldByUom ? props.soldByUom : "",
        soldbybox: props.soldByBox ? props.soldByBox : "",
        templatetype: props.templateType ? props.templateType : "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cart-landing-recalculate__tile-calculator__title",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: props.staticTexts.cartLandingCalculatorTitle
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cart-landing-recalculate__tile-calculator__description",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: tempVal ? props.staticTexts.cartLandingCalculatorDescriptionLF : props.staticTexts.cartLandingCalculatorDescription
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "inputWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inputBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inputBoxLabel",
                                children: [
                                    tempVal ? props.staticTexts.linearFtNeeded : props.staticTexts.squareFtNeeded,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: tooltip/* default */.Z === null || tooltip/* default */.Z === void 0 ? void 0 : tooltip/* default.src */.Z.src,
                                        alt: "",
                                        role: "tooltip",
                                        tabIndex: 0,
                                        onMouseOver: ()=>{
                                            var ref;
                                            return trimTooltipHandler(true, false, false, (props === null || props === void 0 ? void 0 : (ref = props.customLabel) === null || ref === void 0 ? void 0 : ref.ftneededToolTip) ? props.customLabel.ftneededToolTip : ftNeededTooltipStaticText);
                                        },
                                        onMouseLeave: ()=>setTrimTooltip({
                                                sqFeetTooltip: false,
                                                overageTooltip: false,
                                                totalCoverageTooltip: false
                                            }),
                                        className: "trimCalculatorTooltipIcon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "trim-calculator__list-tooltip".concat(trimTooltip.sqFeetTooltip ? "--show" : "--hide"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "trim-calculator__list-tooltip-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                message: (props === null || props === void 0 ? void 0 : (ref4 = props.customLabel) === null || ref4 === void 0 ? void 0 : ref4.ftneededToolTip) ? props.customLabel.ftneededToolTip : ftNeededTooltipStaticText
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "number",
                                className: "trim-calculator__square-ft-value",
                                id: "txt_prod_price",
                                value: displayVal ? displayVal : linerLF,
                                onChange: (e)=>onChangeHandler(e.target.value),
                                onBlur: (e)=>onBlurHandler(e.target.value, true, true)
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "labelLF",
                                children: tempVal ? props.staticTexts.lf : props.staticTexts.sf
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inputBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                className: "inputBoxLabel",
                                children: [
                                    (props === null || props === void 0 ? void 0 : (ref5 = props.customLabel) === null || ref5 === void 0 ? void 0 : ref5.overagename) ? props.customLabel.overagename : props.staticTexts.overage,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: tooltip/* default */.Z === null || tooltip/* default */.Z === void 0 ? void 0 : tooltip/* default.src */.Z.src,
                                        alt: "",
                                        role: "tooltip",
                                        tabIndex: 0,
                                        onMouseOver: ()=>{
                                            var ref;
                                            return trimTooltipHandler(false, true, false, (props === null || props === void 0 ? void 0 : (ref = props.customLabel) === null || ref === void 0 ? void 0 : ref.overageNameToolTip) ? props.customLabel.overageNameToolTip : props.staticTexts.overage);
                                        },
                                        onMouseLeave: ()=>setTrimTooltip({
                                                sqFeetTooltip: false,
                                                overageTooltip: false,
                                                totalCoverageTooltip: false
                                            }),
                                        className: "trimCalculatorTooltipIcon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "trim-calculator__list-tooltip".concat(trimTooltip.overageTooltip ? "--show" : "--hide"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "trim-calculator__list-tooltip-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                message: (props === null || props === void 0 ? void 0 : (ref6 = props.customLabel) === null || ref6 === void 0 ? void 0 : ref6.overageNameToolTip) ? props.customLabel.overageNameToolTip : props.staticTexts.overage
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SelectDropdown/* default */.Z, {
                                data: overageList,
                                value: overage,
                                onChange: (selectedValue)=>onChangeOverage(selectedValue, true, false),
                                id: "trim-calculator__overage-value"
                            }),
                            (overage === "custom" || overage === "Custom") && /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                type: "number",
                                value: customOverage,
                                onChange: (e)=>onChangeCustomOverage(e.target.value),
                                onBlur: onCustomOverageBlur,
                                id: "trim-calculator__overage-input-box"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "totalLFWrapper",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "labelText",
                        children: tempVal ? props.staticTexts.totalLF : props.staticTexts.totalSF
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "valText",
                        id: "trim-calculator__totalSquareFeet",
                        value: Number(displayValSF) ? (ref7 = Number(displayValSF)) === null || ref7 === void 0 ? void 0 : ref7.toFixed(3) : totalLF.toFixed(3),
                        children: [
                            Number(displayValSF) ? (ref8 = Number(displayValSF)) === null || ref8 === void 0 ? void 0 : ref8.toFixed(3) : totalLF.toFixed(3),
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: "text",
                                children: tempVal ? props.staticTexts.lf : props.staticTexts.sf
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "totalBox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "leftBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.staticTexts.totalCoverage
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    props.staticTexts.whatYouWillReceive,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: tooltip/* default */.Z === null || tooltip/* default */.Z === void 0 ? void 0 : tooltip/* default.src */.Z.src,
                                        alt: "",
                                        role: "tooltip",
                                        tabIndex: 0,
                                        onMouseOver: ()=>{
                                            var ref;
                                            return trimTooltipHandler(false, false, true, (props === null || props === void 0 ? void 0 : (ref = props.customLabel) === null || ref === void 0 ? void 0 : ref.totalCoverageToolTip) ? props.customLabel.totalCoverageToolTip : props.staticTexts.totalCoverage);
                                        },
                                        onMouseLeave: ()=>setTrimTooltip({
                                                sqFeetTooltip: false,
                                                overageTooltip: false,
                                                totalCoverageTooltip: false
                                            }),
                                        className: "trimCalculatorTooltipIcon"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "trim-calculator__list-tooltip".concat(trimTooltip.totalCoverageTooltip ? "--show" : "--hide"),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "trim-calculator__list-tooltip-wrapper",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                                                message: (props === null || props === void 0 ? void 0 : (ref9 = props.customLabel) === null || ref9 === void 0 ? void 0 : ref9.totalCoverageToolTip) ? props.customLabel.totalCoverageToolTip : props.staticTexts.totalCoverage
                                            })
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rightBox",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "valText",
                            id: "trim-calculator__totalCoverage",
                            value: isUserInput ? totalOverage.toFixed(2) : props === null || props === void 0 ? void 0 : props.totalArea,
                            children: [
                                isUserInput ? totalOverage.toFixed(2) : props === null || props === void 0 ? void 0 : props.totalArea,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text",
                                    children: "".concat(tempVal ? "LF" : "SF")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "totalBox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "leftBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: tempVal ? props.staticTexts.totalPieces : props.staticTexts.totalBoxes
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: "".concat(tempVal ? "Trim" : "Tile", " sold by the ").concat(tempVal ? "piece" : "box", " (").concat(totalSoldValue.toFixed(2), " ").concat(tempVal ? "LF / Each" : "SF / Box", ")")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rightBox",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "valText",
                            id: "trim-calculator__totalBoxes",
                            value: isUserInput ? stockValue < pises ? stockValue : pises : props === null || props === void 0 ? void 0 : props.totalBoxes,
                            children: [
                                isUserInput ? stockValue < pises ? stockValue : pises : props === null || props === void 0 ? void 0 : props.totalBoxes,
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: "text",
                                    children: "".concat(tempVal ? "PIECES" : "BOXES")
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "totalBox",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "leftBox",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: props.staticTexts.totalPrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                                children: "".concat(tempVal ? "Price / Ea" : "Price / Box", " ").concat(props.discountPrice > 0 ? props.discountPrice : props.priceByBox)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "rightBox",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "finalTotal",
                            id: "trim-calculator__finalTotal",
                            price: isUserInput ? price.toFixed(2) : props === null || props === void 0 ? void 0 : props.totalPrice,
                            children: "$".concat(isUserInput ? price.toFixed(2) : props === null || props === void 0 ? void 0 : props.totalPrice)
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cart-landing-recalculate__add-to-cart",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                    href: "#",
                    className: "cart-landing-recalculate__add-to-cart-btn",
                    onClick: updateCartHandler,
                    children: props.i18n.recalculateUpdateCart
                })
            })
        ]
    });
};
/* harmony default export */ var TrimCalculator = (PDPTrimCalculator);

;// CONCATENATED MODULE: ./components/cart/RecalculateModal/index.jsx




const RecalculateModal = (props)=>{
    var ref;
    const isShow = props.isShow;
    const i18n = props.i18n;
    const showHideClass = isShow ? "modal-display-block" : "modal-display-none";
    const { allAdditinalInfo: { discountPrice ="" , price =""  } = {}  } = props !== null && props !== void 0 ? props : {};
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "cart-landing-recalculate__modal-popup ".concat(showHideClass),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "cart-landing-recalculate",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cart-landing-recalculate__container",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart-landing-recalculate__tile-calculator",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: icons_close/* default */.Z === null || icons_close/* default */.Z === void 0 ? void 0 : icons_close/* default.src */.Z.src,
                                alt: "",
                                onClick: props.onClose,
                                className: "cart-landing-recalculate__tile-calculator__closeImg"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TrimCalculator, {
                                shwoInModal: "yes",
                                totalNeeded: props.allAdditinalInfo.totalNeeded,
                                totalArea: props.allAdditinalInfo.totalArea,
                                overage: props.allAdditinalInfo.overage,
                                soldByBox: props.allAdditinalInfo.soldByBox,
                                soldByUom: props.allAdditinalInfo.soldByUom,
                                priceByBox: props.allAdditinalInfo.price,
                                templateType: props.allAdditinalInfo.templateType,
                                staticTexts: props.i18n,
                                discountPrice: props.allAdditinalInfo.discountPrice,
                                totalPrice: props.allAdditinalInfo.totalPrice,
                                totalBoxes: props.allAdditinalInfo.totalBoxes,
                                productInfo: props === null || props === void 0 ? void 0 : props.productInfo,
                                updateRecalculateCarts: props.updateRecalculateCarts,
                                i18n: i18n,
                                totalSFNeeded: props === null || props === void 0 ? void 0 : (ref = props.allAdditinalInfo) === null || ref === void 0 ? void 0 : ref.totalSFNeeded,
                                ...props
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "cart-landing-recalculate__footer",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "cart-landing-recalculate__footer__body",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: props.allAdditinalInfo ? props.allAdditinalInfo.image : "",
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-landing-recalculate__footer__contents",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "title",
                                    children: props.allAdditinalInfo ? props.allAdditinalInfo.name : ""
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-landing-recalculate__footer__price-details",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                    className: "price",
                                    children: [
                                        props.allAdditinalInfo ? props.allAdditinalInfo.currencySign : "",
                                        Number(discountPrice) ? discountPrice : price
                                    ]
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var cart_RecalculateModal = (RecalculateModal);

// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 16 modules
var esm = __webpack_require__(24400);
// EXTERNAL MODULE: ./components/Bundles/StaticBundle/index.jsx + 1 modules
var StaticBundle = __webpack_require__(5852);
// EXTERNAL MODULE: ./components/Bundles/localization.js
var localization = __webpack_require__(60303);
// EXTERNAL MODULE: ./components/Bundles/StaticBundle/BundlesViewDetails/index.module.scss
var index_module = __webpack_require__(87223);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./components/Bundles/analytics/index.js
var Bundles_analytics = __webpack_require__(34252);
;// CONCATENATED MODULE: ./components/Bundles/StaticBundle/BundlesViewDetails/index.jsx







const BundlesViewDetails = (props)=>{
    const { lineItem =[] , bundleItemsCount =0 , productInfoData ={} , page ={}  } = props;
    const { t  } = (0,esm/* useTranslation */.$G)("common");
    const { includedItemsQty =()=>{} , viewDetails =""  } = (0,localization/* getTranslations */.F)(t);
    const [viewBundle, setViewBundle] = (0,react.useState)("");
    const viewBundleDetails = ()=>{
        setViewBundle(!viewBundle);
        const collapseTitle = !viewBundle ? "expand" : "collapse";
        const productInfo = (productInfoData === null || productInfoData === void 0 ? void 0 : productInfoData.length) > 0 ? JSON.parse(productInfoData) : null;
        (0,Bundles_analytics/* viewDetailsBundleAnalytics */.JP)(collapseTitle, productInfo);
    };
    const staticBundleData = {
        lineItem
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (index_module_default()).PreviewCartBundleSection,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "preview-bundle-included",
                children: includedItemsQty(bundleItemsCount)
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "view-bundle-details ".concat(viewBundle ? "bundle-open" : ""),
                onClick: viewBundleDetails,
                children: viewDetails
            }),
            viewBundle ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticBundle/* default */.Z, {
                data: staticBundleData,
                isViewBundle: true,
                page: page
            }) : null
        ]
    });
};
/* harmony default export */ var StaticBundle_BundlesViewDetails = (BundlesViewDetails);

// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./public/images/error-qty.svg
var error_qty = __webpack_require__(832);
// EXTERNAL MODULE: ./store/features/genericSlice.js
var genericSlice = __webpack_require__(88751);
// EXTERNAL MODULE: ./components/OrderConfirmation/OrderDetailsTabs/constant.js
var constant = __webpack_require__(6055);
// EXTERNAL MODULE: ./utils/dateHelper.js + 40 modules
var dateHelper = __webpack_require__(64443);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/date-fns/startOfDay.mjs
var startOfDay = __webpack_require__(45459);
;// CONCATENATED MODULE: ./components/cart/OrderCancellationDetails/index.jsx





const OrderCancellationDetails = (param)=>{
    let { cancellationInfo =[] , i18n: { singleCancelledOrder , multiCancelledOrder  } = {} , cancelledQuantity , availableQty  } = param;
    if (!cancellationInfo.length) return null;
    const normalizeDate = (date)=>{
        const parsed = (0,dateHelper/* parseDate */.sG)(date);
        return parsed ? (0,startOfDay/* startOfDay */.b)(parsed) : null;
    };
    const groupedCancellationDate = Object.values(cancellationInfo.reduce((acc, param)=>{
        let { cancelledDate ="" , quantity =0  } = param;
        const normalized = normalizeDate(cancelledDate);
        if (!normalized) return acc // skip invalid dates silently
        ;
        const key = (0,dateHelper/* formatDate */.p6)(normalized, "MM/dd/yy");
        if (!acc[key]) {
            acc[key] = {
                cancelledDate: normalized,
                quantity: 0
            };
        }
        acc[key].quantity += quantity;
        return acc;
    }, {})).sort((a, b)=>b.cancelledDate - a.cancelledDate);
    const isFullyCancelled = cancelledQuantity === availableQty;
    if (groupedCancellationDate.length === 1) {
        const { cancelledDate , quantity  } = groupedCancellationDate[0];
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: isFullyCancelled ? singleCancelledOrder((0,dateHelper/* formatDate */.p6)(cancelledDate, "MM/dd/yy")) : multiCancelledOrder(quantity, (0,dateHelper/* formatDate */.p6)(cancelledDate, "MM/dd/yy"))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: groupedCancellationDate.map((param)=>{
            let { cancelledDate , quantity  } = param;
            var ref;
            const key = "".concat((cancelledDate === null || cancelledDate === void 0 ? void 0 : (ref = cancelledDate.getTime) === null || ref === void 0 ? void 0 : ref.call(cancelledDate)) || "", "-").concat(quantity);
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: multiCancelledOrder(quantity, (0,dateHelper/* formatDate */.p6)(cancelledDate, "MM/dd/yy"))
            }, key);
        })
    });
};
OrderCancellationDetails.propTypes = {
    cancellationInfo: prop_types_default().arrayOf(prop_types_default().shape({
        cancelledDate: (prop_types_default()).string.isRequired,
        quantity: (prop_types_default()).number.isRequired
    })),
    cancelledQuantity: (prop_types_default()).number,
    quantity: (prop_types_default()).number,
    i18n: (prop_types_default()).object,
    availableQty: (prop_types_default()).number
};
/* harmony default export */ var cart_OrderCancellationDetails = (OrderCancellationDetails);

// EXTERNAL MODULE: ./components/checkout/v2/analytics/index.js
var v2_analytics = __webpack_require__(37490);
;// CONCATENATED MODULE: ./components/cart/CartItemTile/index.jsx
































const CartItemTile = (props)=>{
    var ref, ref1, ref2, ref3, ref4;
    const { data ={} , checkoutMode , i18n ={} , isDeliveryOption , comboChild , loading , orderMode , hideAlerts , page , is3COrder , linkCustomAnalyticsData , linkAnalyticsData ="" , trackingLinkAnalyticsData ="" , email ="" , showRadio , isAlert , isCartPage , isHideItemPrice , isModel =false , handleRoomInfoUpdate , presetConfigs ="" , activeTab ="" , includeBackorderToolTip =false , backOrderTooltipMessage ={} , isShippingAlert =false , zipCode ="" , returnDefectInfo ={} , parcels =[] , deliveryMethod ={}  } = props || {};
    const { availableQty =0 , quantity =0 , discountPrice =0 , unitPrice =0 , totalPrice =0 , category ="" , slug ="" , sku ="" , status ="" , discountedPricePerQuantity =0 , discountedPriceProductLevel =0 , isBundleParent =false , bundleLineItems =[] , bundleItemsCount =0 , id ="" , isComboSku ="" , backOrder =false , cancellationInfo =[] , cancelledQuantity , isBundleChildItem  } = data;
    const { returnCancelledMessage ="" , returnRejectedMessage =""  } = returnDefectInfo;
    const { availableToShipMsg =()=>{} , outOfStock ="" , outOfStockText ="" , locationLabel ="" , inPersonLabel =""  } = i18n;
    const { qtyLoading  } = (0,es/* useSelector */.v9)(cartSlice/* selectCartState */.xw);
    const [width] = (0,useWindowResize/* default */.Z)();
    const discountVal = (0,helper/* isPriceZero */.YN4)(discountedPricePerQuantity) ? discountedPriceProductLevel : discountedPricePerQuantity;
    const [prodQuantity, setProdQuantity] = (0,react.useState)(data.quantity);
    const [alert, setAlert] = (0,react.useState)({
        show: false,
        mssg: ""
    });
    const [currencySign, setCurrencySign] = (0,react.useState)("");
    const [productAria, setProductAria] = (0,react.useState)("");
    const [partsModal, setPartsModal] = (0,react.useState)(false);
    const siteName = (0,react.useRef)(null);
    const [action, setAction] = (0,react.useState)("remove");
    const [allAdditinalInfo, setAllAdditinalInfo] = (0,react.useState)({});
    const [isModalShow, setIsModalShow] = (0,react.useState)(false);
    var ref5;
    const [imageUrl, setImageUrl] = (0,react.useState)((ref5 = data === null || data === void 0 ? void 0 : data.image) !== null && ref5 !== void 0 ? ref5 : "");
    const [pdpNavigationURL, setPdpNavigationURL] = (0,react.useState)("");
    const [scene7AccountName, setScene7AccountName] = (0,react.useState)("");
    const [swatchUrl, setSwatchUrl] = (0,react.useState)("");
    const [showTooltip, setShowTooltip] = (0,react.useState)(false);
    const { featureFlags ={}  } = (0,es/* useSelector */.v9)(genericSlice/* selectGenericState */.Px);
    const { MYSQLCONNSTR_ENABLE_ORDER_DETAILS_TABS: isEnableTabView = false  } = featureFlags;
    const isReturnItem = (0,utils/* checkReturnStatus */.PZ)(status);
    const isReturnCancelledOrRejected = status === constant/* LINE_ITEM_STATUS_RETURN_CANCELLED */.Ur || status === constant/* LINE_ITEM_STATUS_RETURN_REJECTED */.Pl;
    (0,react.useEffect)(()=>{
        if (!(qtyLoading || loading)) {
            setProdQuantity(data.quantity);
        }
        (0,helper/* getPDPUrl */.ir5)(category, slug).then((ret)=>{
            let pdpUrl = ret;
            if (sku) {
                if (pdpUrl.indexOf("?") > -1) {
                    pdpUrl = pdpUrl + "&skuId=" + sku;
                } else {
                    pdpUrl = pdpUrl + "?skuId=" + sku;
                }
            }
            setPdpNavigationURL(pdpUrl);
        });
    }, [
        data
    ]);
    // Check if the item is a service item
    const isServiceItem = (0,utils/* servicesItem */.bO)(data === null || data === void 0 ? void 0 : data.category);
    (0,react.useEffect)(()=>{
        if (!(qtyLoading || loading)) {
            setProdQuantity(data.quantity);
        }
    }, [
        qtyLoading,
        loading
    ]);
    (0,react.useEffect)(()=>{
        const productAria = "".concat(data.name, ". ").concat(data.desc, ". ").concat(i18n.colorFinish, ": ").concat(data.color, ". ").concat(i18n.qty, ": ").concat(quantity, ". ").concat(i18n.unitPrice, ": ").concat(currencySign).concat(discountPrice > 0 ? discountPrice : unitPrice, ". ").concat(i18n.total, ": ").concat(currencySign).concat(totalPrice, ".");
        setProductAria(productAria);
    }, [
        data
    ]);
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then((config)=>{
            const currency = get_default()(config, "internationalization.currencySign", "");
            setCurrencySign(currency);
            siteName.current = get_default()(config, "general.siteName", "");
            const { general: { scene7AccountName ="" , swatchUrl =""  }  } = config;
            setScene7AccountName(scene7AccountName);
            setSwatchUrl(swatchUrl);
        });
        const presetConfigsData = presetConfigs ? JSON.parse(presetConfigs) : {};
        (0,helper/* checkIfImageExists */.Oh7)(data === null || data === void 0 ? void 0 : data.image, (exists)=>{
            if (exists) {
                var ref, ref1;
                if (includeBackorderToolTip || isShippingAlert) {
                    setImageUrl("".concat(data === null || data === void 0 ? void 0 : data.image, "?bgc=f9f9f9"));
                } else if (!isEmpty_default()(presetConfigsData) && ((ref = siteName.current) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === (data === null || data === void 0 ? void 0 : (ref1 = data.brand) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase())) {
                    const presetImageUrl = (0,helper/* getPresetUrl */.v$f)(width, swatchUrl, data === null || data === void 0 ? void 0 : data.image, presetConfigsData, scene7AccountName);
                    (0,helper/* checkIfImageExists */.Oh7)(presetImageUrl, (exists)=>{
                        if (exists) {
                            setImageUrl(presetImageUrl);
                        }
                    });
                }
            } else {
                setImageUrl(image_missing/* default */.Z);
            }
        });
    }, []);
    const handleError = (e)=>{
        e.stopPropagation();
        setImageUrl(image_missing/* default */.Z);
    };
    const handleCallBack = (stock)=>{
        if (stock) {
            const mssg = availableToShipMsg(stock);
            setAlert({
                show: true,
                mssg: mssg
            });
        } else {
            setAlert({
                show: true,
                mssg: outOfStock
            });
        }
    };
    const handleChange = (qty)=>{
        setProdQuantity(qty);
        setAlert({
            show: false,
            mssg: ""
        });
        const payload = {
            id,
            sku,
            quantity: qty,
            isComboSku,
            isBundleParent,
            stockCheck: (0,helper/* checkStock */.yyd)(backOrder, category),
            cb: handleCallBack,
            staticText: i18n,
            zipCode
        };
        (0,cartHelper/* handleQuantityChange */.bQ)(payload);
    };
    const { additionalData: { roomInfo =[] , overage: totalOverageVal = ""  } = {}  } = data;
    const roomInfoDetailsTotal = roomInfo.length;
    const { totalSFNeeded =0 , totalArea ="" , totalUserNeeded =0 , totalSFUserNeeded =0 , totalNeeded =0 , productType ="" , soldByBox ="" , soldByUom =""  } = roomInfo[0] ? JSON.parse(roomInfo[0]) : {};
    const showMeasurementVal = productType ? productType === null || productType === void 0 ? void 0 : productType.toLowerCase() : "";
    const handleRecalculateModalClose = ()=>{
        setIsModalShow(!isModalShow);
        (0,cartAnalytics/* addDatalayer */.au)({
            title: "close",
            section: "recalculate your space modal",
            productInfo: data === null || data === void 0 ? void 0 : data.customProductInfo
        });
    };
    const handleRecalculateModalOpen = (e)=>{
        setAllAdditinalInfo((0,utils/* getAllAdditinalInfo */.Hr)(e));
        setIsModalShow(!isModalShow);
        (0,cartAnalytics/* addDatalayer */.au)({
            title: "recalculate footage",
            section: "cart items",
            productInfo: data === null || data === void 0 ? void 0 : data.customProductInfo
        });
    };
    const updateRecalculateCarts = ()=>{
        let customQuantity = 0;
        let additionalInfo = {};
        const updateCartAttr = document.querySelector(".trim-calculator_main-block") && document.querySelector(".trim-calculator_main-block") !== null ? document.querySelector(".trim-calculator_main-block").getAttribute("templatetype") : "";
        if (updateCartAttr === "trim" || updateCartAttr === "tile") {
            var ref, ref1;
            let totalArea = 0;
            let totalOverage = Number(document.querySelector("#trim-calculator__overage-value-selected") ? (ref = document.querySelector("#trim-calculator__overage-value-selected")) === null || ref === void 0 ? void 0 : ref.innerText : "");
            var ref2;
            totalOverage = (ref2 = (ref1 = document.querySelector("#trim-calculator__overage-input-box")) === null || ref1 === void 0 ? void 0 : ref1.value) !== null && ref2 !== void 0 ? ref2 : totalOverage;
            let customQuantityTmp = "";
            let soldByBox = "";
            let soldByUom = "";
            let totalNeeded = 0;
            if (document.querySelector(".trim-calculator_main-block")) {
                customQuantityTmp = Number(document.querySelector(".trim-calculator_main-block").getAttribute("totalpeices"));
                soldByUom = Number(document.querySelector(".trim-calculator_main-block").getAttribute("soldbyuom"));
                soldByBox = Number(document.querySelector(".trim-calculator_main-block").getAttribute("soldbybox"));
                totalArea = Number(document.querySelector(".trim-calculator_main-block").getAttribute("totaloverage"));
                totalNeeded = Number(document.querySelector(".trim-calculator__square-ft-value") ? document.querySelector(".trim-calculator__square-ft-value").value : "");
                customQuantity = customQuantityTmp && customQuantityTmp > 0 ? customQuantityTmp : 0;
            }
            if (totalArea !== "" && totalArea > 0 || totalOverage !== "") {
                additionalInfo = {
                    productType: updateCartAttr,
                    totalNeeded: totalNeeded,
                    totalArea: totalArea.toFixed(2),
                    soldByBox: soldByBox,
                    soldByUom: soldByUom,
                    customQuantity: customQuantity,
                    overage: totalOverage.toString(),
                    roomInfo: true
                };
            }
        }
        if (customQuantity > 0 && data.sku) {
            handleRoomInfoUpdate(data.sku, customQuantity, additionalInfo);
        }
        setIsModalShow(!isModalShow);
    };
    const discountPriceProduct = Number(data.discountPrice);
    const customerFacingSKUId = data.customerFacingSKU || data.sku;
    var ref6;
    const cartItemProductInfo = (ref6 = linkCustomAnalyticsData !== null && linkCustomAnalyticsData !== void 0 ? linkCustomAnalyticsData : data.customProductInfo) !== null && ref6 !== void 0 ? ref6 : JSON.stringify({
        productInfo: {
            productBrand: (ref = siteName.current) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: (0,helper/* sanitizeTextForAnalytics */.T68)(data.desc),
            globalPromotionPrice: discountPriceProduct ? discountPriceProduct : Number(data.unitPrice),
            priceState: data.discountPercent > 0 ? "percentOff|" + data.discountPercent : "regular price",
            productBasePrice: Number(data.unitPrice),
            productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(data.category),
            productColor: (0,helper/* sanitizeTextForAnalytics */.T68)(data.color) || "n/a",
            productID: customerFacingSKUId,
            productName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.name),
            productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(data.category),
            productSalePrice: discountPriceProduct ? discountPriceProduct : Number(data.unitPrice),
            productStatus: data.outOfStock && data.availableQty < 1 ? "out of stock" : "in stock",
            productSuperSku: data.superSku ? true : false,
            productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.name),
            quantity: data.quantity,
            defaultImageName: data.image,
            productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.productCollectionsName || data.category),
            productCoupondiscount: "n/a",
            productPartnerBuyNow: "true",
            productSaleable: "true",
            isRecommended: "true",
            isSendNow: "true",
            isSubscription: "true",
            frequency: "n/a",
            ratings: "n/a",
            numberOfReviews: "n/a",
            pdpType: isBundleParent || (data === null || data === void 0 ? void 0 : data.isBundleChildItem) ? "bundle" : (0,helper/* pdpTypeFormat */.V4r)({
                businessUnitName: data.businessUnitName,
                ProductIsRetail: data.ProductIsRetail,
                discontinuedProductb: data.discontinuedProductb,
                ProductRequiredAccessoriesGroupsList: data.ProductRequiredAccessoriesGroupsList,
                superSku: data.superSku
            }),
            productFindingMethod: "n/a"
        }
    });
    const isMsgStatus = (0,cartHelper/* getMessageStatus */.vC)({
        data,
        email,
        hideAlerts,
        i18n,
        checkoutMode
    });
    const isMsgMobileStatus = (0,cartHelper/* getMessageStatus */.vC)({
        data,
        email,
        hideAlerts,
        i18n,
        isMobile: true,
        alert
    });
    const handleRemoveItem = ()=>{
        const payloadData = {
            id,
            quantity,
            isBundle: isComboSku,
            isBundleParent,
            sku,
            isComboSku
        };
        const bundleLocalStorage = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem("bundleItems");
        if (bundleLocalStorage) {
            (0,analytics/* cartBundleFinishAnalytics */.Xh)(bundleLocalStorage, payloadData);
        }
        (0,cartHelper/* removeCartItem */.B8)(payloadData);
        (0,cartAnalytics/* addRemoveProductFromCartAnalytics */.UN)("cmp:click", isBundleParent || (data === null || data === void 0 ? void 0 : data.isBundleChildItem), cartItemProductInfo ? JSON.parse(cartItemProductInfo) : "");
    };
    const handleProductClickAnalytics = ()=>{
        const eventInfo = (0,cartAnalytics/* addCartItemSummaryAnalytics */.Jk)(page, data.desc, data.name, pdpNavigationURL, isBundleParent || (data === null || data === void 0 ? void 0 : data.isBundleChildItem), isEnableTabView, activeTab);
        (0,analytics/* cartItemSummaryAnalytics */.$y)(eventInfo, cartItemProductInfo);
    };
    const isAsProduct = (data === null || data === void 0 ? void 0 : (ref1 = data.sourceBrand) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase()) === (constants.annSacksConstants === null || constants.annSacksConstants === void 0 ? void 0 : constants.annSacksConstants.asSourceChannel);
    const shouldRenderQuantity = isEnableTabView ? !isComboSku : !comboChild;
    const shouldRenderTrackingButtons = function() {
        let trackingLinks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], svgId = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", isTabsEnabled = arguments.length > 2 ? arguments[2] : void 0;
        if (isTabsEnabled) {
            return trackingLinks.length > 0;
        } else {
            return !!(trackingLinks || svgId);
        }
    };
    let shouldRenderPrice;
    if (isEnableTabView) {
        shouldRenderPrice = orderMode ? comboChild || !isComboSku : !comboChild;
    } else {
        shouldRenderPrice = !comboChild;
    }
    const backOrderTooltip = ()=>{
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "cart-item__tooltip",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: small_tooltip/* default.src */.Z.src,
                        alt: "",
                        onMouseOver: (e)=>handleInfoToolTipHover(e),
                        onMouseLeave: ()=>setShowTooltip(false),
                        width: "16px",
                        height: "16px"
                    }),
                    showTooltip && /*#__PURE__*/ (0,jsx_runtime.jsx)(ToolTip/* default */.Z, {
                        message: backOrderTooltipMessage === null || backOrderTooltipMessage === void 0 ? void 0 : backOrderTooltipMessage.value
                    })
                ]
            })
        });
    };
    const handleInfoToolTipHover = (e)=>{
        e.stopPropagation();
        setShowTooltip(true);
        if (includeBackorderToolTip) {
            (0,v2_analytics/* addAnalyticsBackOrderTooltip */.Ht)({
                title: i18n === null || i18n === void 0 ? void 0 : i18n.backOrderMssg(data === null || data === void 0 ? void 0 : data.leadTime).toLowerCase(),
                parcels,
                deliveryMethod,
                tooltipMsg: backOrderTooltipMessage === null || backOrderTooltipMessage === void 0 ? void 0 : backOrderTooltipMessage.value.toLowerCase()
            });
        }
    };
    const isService = constants.SERVICES.includes(category);
    const shapeSizeDesignArray = [];
    if (data === null || data === void 0 ? void 0 : data.shape) shapeSizeDesignArray.push(data === null || data === void 0 ? void 0 : data.shape);
    if (data === null || data === void 0 ? void 0 : data.size) shapeSizeDesignArray.push(data === null || data === void 0 ? void 0 : data.size);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            isModalShow && /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_RecalculateModal, {
                allAdditinalInfo: allAdditinalInfo,
                updateRecalculateCarts: updateRecalculateCarts,
                onClose: handleRecalculateModalClose,
                isShow: isModalShow,
                i18n: i18n,
                productInfo: data === null || data === void 0 ? void 0 : data.customProductInfo,
                sku: sku,
                stockValue: quantity
            }),
            comboChild && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "cart-item__item-of",
                children: !isEnableTabView ? i18n.itemOf(comboChild.index, comboChild.count) : ""
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "row cart-item no-gutters",
                children: [
                    partsModal && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                        page: "cart",
                        i18n: i18n,
                        productId: data.svgProductId,
                        showModal: partsModal,
                        partId: data.svgId,
                        onClose: ()=>setPartsModal(false),
                        analyticsCustomData: cartItemProductInfo
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "col-12 ".concat(!checkoutMode ? "col-sm-6" : "col-sm-12", " mobile-full-width ").concat(checkoutMode ? "col-sm-12" : isDeliveryOption || isAlert || orderMode ? "col-md-8" : "col-md-6", " print-left ").concat(comboChild && orderMode ? "cart-item__combo-item col-md-6" : comboChild ? "cart-item__combo-item col-md-12" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cart-item__summary",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    className: "gbh-data-layer",
                                    tabIndex: 0,
                                    href: pdpNavigationURL,
                                    onClick: handleProductClickAnalytics,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        className: "cart-item__image",
                                        src: imageUrl,
                                        alt: (0,utils/* getProductImageAlt */.BS)(data),
                                        width: 300,
                                        height: 300,
                                        onError: handleError
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    className: "cart-item__specs ".concat(isEnableTabView ? "cart-item__specs-tabs" : ""),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "row no-gutters",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "col-12 col-sm-6 col-md-7 cart-item-desc__name",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "cart-item__brand",
                                                            children: data.brand && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "cart-item__brand-name",
                                                                children: data.brand
                                                            })
                                                        }),
                                                        comboChild && isDeliveryOption && data.name ? /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "cart-item__desc",
                                                            children: data.desc
                                                        }) : null,
                                                        !comboChild && /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                            href: pdpNavigationURL,
                                                            role: "button",
                                                            className: "cart-item__name-desc",
                                                            tabIndex: -1,
                                                            "aria-description": productAria,
                                                            "aria-hidden": "true",
                                                            onClick: handleProductClickAnalytics,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "cart-item__name",
                                                                    children: [
                                                                        data.name || data.desc,
                                                                        " "
                                                                    ]
                                                                }),
                                                                data.name && data.name !== data.desc && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "cart-item__desc",
                                                                    children: data.desc
                                                                })
                                                            ]
                                                        }),
                                                        checkoutMode && zipCode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "location",
                                                            children: [
                                                                locationLabel,
                                                                ": ",
                                                                zipCode,
                                                                " (",
                                                                inPersonLabel,
                                                                ")"
                                                            ]
                                                        }) : null,
                                                        (data === null || data === void 0 ? void 0 : data.additionalData) && roomInfoDetailsTotal > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "cart-landing-recalculate__recalculate-main-block",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                className: "cart-landing-recalculate__recalculate-main-block-second",
                                                                children: [
                                                                    i18n.coverage,
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                        className: "cart-landing-recalculate__overage-label-text",
                                                                        children: [
                                                                            totalArea,
                                                                            " ",
                                                                            showMeasurementVal === "trim" ? "LF" : "SF"
                                                                        ]
                                                                    }),
                                                                    !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                            href: "#",
                                                                            className: "cart-landing-recalculate__popup-link",
                                                                            onClick: (e)=>handleRecalculateModalOpen(e),
                                                                            "data-totalneeded": totalNeeded,
                                                                            "data-name": data.name ? data.name : data.desc,
                                                                            "data-desc": data.desc,
                                                                            "data-image": data.image,
                                                                            "data-currencysign": currencySign,
                                                                            "data-price": data.unitPrice,
                                                                            "data-totalarea": totalArea,
                                                                            "data-totaloverageval": totalOverageVal,
                                                                            "data-soldbybox": soldByBox,
                                                                            "data-soldbyuom": soldByUom,
                                                                            "data-templatetype": showMeasurementVal,
                                                                            "data-discountprice": data.discountPrice,
                                                                            "data-totalprice": data.totalPrice,
                                                                            "data-totalSFNeeded": totalSFNeeded,
                                                                            "data-totalUserNeeded": totalUserNeeded,
                                                                            "data-totalSFUserNeeded": totalSFUserNeeded,
                                                                            "data-totalBoxes": data === null || data === void 0 ? void 0 : data.quantity,
                                                                            children: "Recalculate"
                                                                        })
                                                                    })
                                                                ]
                                                            })
                                                        }),
                                                        !isService && data.color !== "Not Applicable" && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                !isBundleParent ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                    className: "cart-item__color",
                                                                    children: [
                                                                        i18n.colorFinish,
                                                                        ": ",
                                                                        data.color
                                                                    ]
                                                                }) : null,
                                                                shapeSizeDesignArray.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                    className: "cart-item__shape",
                                                                    children: "".concat(i18n === null || i18n === void 0 ? void 0 : i18n.shape, " \n                            ").concat(shapeSizeDesignArray.join(", "))
                                                                }) : null
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "cart-item__sku",
                                                            children: [
                                                                i18n.sku,
                                                                " : ",
                                                                data.customerFacingSKU || data.sku
                                                            ]
                                                        }),
                                                        includeBackorderToolTip && availableQty < 1 && !backOrder && !isServiceItem && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                            className: "cart-item__outofstock",
                                                            children: outOfStockText
                                                        }),
                                                        !comboChild && status === "Cancelled" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "cart-item__cancellation-details",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_OrderCancellationDetails, {
                                                                i18n: i18n,
                                                                cancellationInfo: cancellationInfo,
                                                                cancelledQuantity: cancelledQuantity,
                                                                availableQty: availableQty,
                                                                quantity: quantity
                                                            })
                                                        }) : null,
                                                        isModel ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "cart-item__qty_mobile",
                                                            children: [
                                                                i18n.qty,
                                                                " : ",
                                                                quantity
                                                            ]
                                                        }) : null,
                                                        !checkoutMode && isBundleParent ? /*#__PURE__*/ (0,jsx_runtime.jsx)(StaticBundle_BundlesViewDetails, {
                                                            lineItem: bundleLineItems,
                                                            bundleItemsCount: bundleItemsCount,
                                                            productInfoData: cartItemProductInfo,
                                                            page: page
                                                        }) : null,
                                                        !checkoutMode && data.isComboSku && !isDeliveryOption && !orderMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "cart-item__note --mobile",
                                                            children: [
                                                                i18n.note,
                                                                ": ",
                                                                i18n.comboSkuMssg
                                                            ]
                                                        }),
                                                        email && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "d-block d-lg-none cart-item__email",
                                                            children: [
                                                                i18n.email,
                                                                ": ",
                                                                email
                                                            ]
                                                        }),
                                                        email && (data.category === "Install Services" || data.category === "Design Services") && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "cart-item__note --e-delivery",
                                                            children: [
                                                                i18n.note,
                                                                ":",
                                                                " ",
                                                                data.category === "Install Services" ? i18n.eDeliveryMsg : i18n.eDeliveryNote
                                                            ]
                                                        }),
                                                        !data.cancelled && hideAlerts && data.backOrder && data.leadTime && includeBackorderToolTip && data.quantity > data.availableQty && i18n.backOrderMssg && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                className: "cart-item__stock-msg checkout-backOrder",
                                                                children: [
                                                                    i18n.backOrderMssg(data.leadTime),
                                                                    includeBackorderToolTip && backOrderTooltip()
                                                                ]
                                                            })
                                                        }),
                                                        isDeliveryOption ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "cart-item__quantity-price",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                    className: "cart-item__label --count",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                            children: [
                                                                                i18n.qtyLabel,
                                                                                " : "
                                                                            ]
                                                                        }),
                                                                        "".concat(data.quantity)
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "cart-item__label --sum",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                        value: data.totalPrice,
                                                                        displayType: "text",
                                                                        thousandSeparator: true,
                                                                        prefix: currencySign,
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true
                                                                    })
                                                                })
                                                            ]
                                                        }) : null,
                                                        !isDeliveryOption && !isCartPage && data.discountPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "cart-item__display-discount --mobile",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "cart-item__discount-price --offPercentage ",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        children: data.discountPercent ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : data.discountAmount ? "".concat(currencySign).concat(data.discountAmount, " ").concat(i18n.off) : ""
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "cart-item__discount-price --mobile",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                        value: data.unitPrice * data.quantity,
                                                                        displayType: "text",
                                                                        thousandSeparator: true,
                                                                        prefix: currencySign,
                                                                        decimalScale: 2,
                                                                        fixedDecimalScale: true
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        (checkoutMode || orderMode) && comboChild && !isDeliveryOption ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                            children: [
                                                                data.name && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "cart-item__desc",
                                                                    children: data.desc
                                                                }),
                                                                status === "Cancelled" ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "cart-item__cancellation-details",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(cart_OrderCancellationDetails, {
                                                                        i18n: i18n,
                                                                        cancellationInfo: cancellationInfo,
                                                                        cancelledQuantity: cancelledQuantity,
                                                                        availableQty: availableQty,
                                                                        quantity: quantity
                                                                    })
                                                                }) : null
                                                            ]
                                                        }) : null,
                                                        !isEnableTabView && orderMode && !isHideItemPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            className: "order-complete-item-price",
                                                            children: [
                                                                i18n.itemPrice,
                                                                ":",
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    value: Number(data.discountPrice) ? data.discountPrice : data.unitPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                Number(data.discountPrice) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "cart-item__span",
                                                                    value: data.unitPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2
                                                                }) : null
                                                            ]
                                                        }) : null,
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "message-container error",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "cart-stock-msg desktop-cart-stock-msg",
                                                                    children: [
                                                                        !isEnableTabView && data.cancelled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "row",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col text-right cart-item__stock-msg",
                                                                                children: i18n.cancelled
                                                                            })
                                                                        }),
                                                                        email && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "".concat(orderMode ? "order-mode-hide" : "row"),
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "cart-item__stock-msg",
                                                                                children: [
                                                                                    i18n.email,
                                                                                    " : ",
                                                                                    email
                                                                                ]
                                                                            })
                                                                        }),
                                                                        !hideAlerts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                alert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "cart-item__stock-msg --error avaiable-qty-error",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "qty-error-icon",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: error_qty/* default */.Z === null || error_qty/* default */.Z === void 0 ? void 0 : error_qty/* default.src */.Z.src,
                                                                                                alt: alert.mssg
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: alert.mssg
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !alert.show && data.outOfStock && data.availableQty < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "text-right cart-item__stock-msg --error",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: i18n.outOfStock
                                                                                    })
                                                                                }),
                                                                                !alert.show && data.outOfStock && data.availableQty > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "cart-item__stock-msg --error avaiable-qty-error",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "qty-error-icon",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: error_qty/* default */.Z === null || error_qty/* default */.Z === void 0 ? void 0 : error_qty/* default.src */.Z.src,
                                                                                                alt: availableToShipMsg(data.availableQty)
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: availableToShipMsg(data.availableQty)
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !alert.show && !data.outOfStock && data.noShipping && !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "cart-item__stock-msg --error",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "error-icon",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: error_qty/* default */.Z === null || error_qty/* default */.Z === void 0 ? void 0 : error_qty/* default.src */.Z.src,
                                                                                                alt: alert.mssg
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: i18n.cannotShip
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        !hideAlerts && data.category !== "Install Services" && data.category !== "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: data.backOrder && data.leadTime && data.quantity > data.availableQty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "cart-item__stock-msg",
                                                                                children: i18n.backOrderMssg(data.leadTime)
                                                                            }) : !alert.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "cart-item__stock-msg",
                                                                                children: data.outOfStock || data.noShipping ? "" : i18n.inStock
                                                                            })
                                                                        }),
                                                                        !data.cancelled && hideAlerts && data.backOrder && data.leadTime && !includeBackorderToolTip && data.quantity > data.availableQty && i18n.backOrderMssg && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                className: "cart-item__stock-msg checkout-backOrder",
                                                                                children: [
                                                                                    i18n.backOrderMssg(data.leadTime),
                                                                                    includeBackorderToolTip && backOrderTooltip()
                                                                                ]
                                                                            })
                                                                        })
                                                                    ]
                                                                }),
                                                                isMsgMobileStatus ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "cart-stock-message-mobile",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "cart-item__qty-mobile",
                                                                            children: "\xa0"
                                                                        }),
                                                                        !isEnableTabView && data.cancelled && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "row",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col text-right cart-item__stock-msg",
                                                                                children: i18n.cancelled
                                                                            })
                                                                        }),
                                                                        email && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            className: "row",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                                                className: "col d-none d-lg-block text-right cart-item__stock-msg",
                                                                                children: [
                                                                                    i18n.email,
                                                                                    " : ",
                                                                                    email
                                                                                ]
                                                                            })
                                                                        }),
                                                                        !hideAlerts && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                            children: [
                                                                                alert.show && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "col cart-item__stock-msg --error avaiable-qty-error",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "qty-error-icon",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: error_qty/* default */.Z === null || error_qty/* default */.Z === void 0 ? void 0 : error_qty/* default.src */.Z.src,
                                                                                                alt: alert.mssg
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: alert.mssg
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                !alert.show && data.outOfStock && data.availableQty < 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "col text-right cart-item__stock-msg --error",
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                        children: i18n.outOfStock
                                                                                    })
                                                                                }),
                                                                                !alert.show && data.outOfStock && data.availableQty > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "col cart-item__stock-msg --error avaiable-qty-error",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            className: "qty-error-icon",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: error_qty/* default */.Z === null || error_qty/* default */.Z === void 0 ? void 0 : error_qty/* default.src */.Z.src,
                                                                                                alt: availableToShipMsg(data.availableQty)
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                            children: availableToShipMsg(data.availableQty)
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        !hideAlerts && data.category !== "Install Services" && data.category !== "Design Services" && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: data.backOrder && data.leadTime && data.quantity > data.availableQty ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "cart-item__stock-msg",
                                                                                children: i18n.backOrderMssg(data.leadTime)
                                                                            }) : !alert.show && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "cart-item__stock-msg",
                                                                                children: data.outOfStock || data.noShipping ? "" : i18n.inStock
                                                                            })
                                                                        }),
                                                                        !data.cancelled && hideAlerts && data.backOrder && data.leadTime && data.quantity > data.availableQty && i18n.backOrderMssg && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                className: "cart-item__stock-msg",
                                                                                children: i18n.backOrderMssg(data.leadTime)
                                                                            })
                                                                        })
                                                                    ]
                                                                }) : null,
                                                                data.noShipping && isBundleChildItem && isShippingAlert ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "error-icon",
                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                src: error_qty/* default */.Z === null || error_qty/* default */.Z === void 0 ? void 0 : error_qty/* default.src */.Z.src,
                                                                                alt: alert.mssg
                                                                            })
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            children: i18n.bundleRestrictionMessage
                                                                        })
                                                                    ]
                                                                }) : null
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                isModel ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "col-12 col-sm-6 col-md-5",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "row px-0 mx-0",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-6 d-none d-sm-block px-0 text-center cart-items__td",
                                                            children: quantity
                                                        })
                                                    })
                                                }) : null
                                            ]
                                        }),
                                        isEnableTabView && isReturnItem && !isComboSku ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "cart-item__return_description ".concat(isReturnCancelledOrRejected ? "text-error" : ""),
                                            children: (0,html_react_parser/* default */.ZP)((0,utils/* getReturnStatusDescription */.WS)(status, i18n, returnCancelledMessage, returnRejectedMessage))
                                        }) : null
                                    ]
                                })
                            ]
                        })
                    }),
                    !checkoutMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "col-12 col-sm-6 ".concat(orderMode ? "col-md-4" : isAlert ? "col-md-4" : "col-md-6", " cart-item__info print-right"),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "row cart-item__qty-price cart-qty-price-mobile mx-0 px-0",
                                children: [
                                    isEnableTabView && !isComboSku ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item-spacer-non-comboskus"
                                    }) : null,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item__qty-mobile ".concat(isEnableTabView ? "compact" : ""),
                                        children: "\xa0"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "".concat(isDeliveryOption || isAlert ? "col-6" : orderMode ? "col-6" : "col-4", " cart-item__qty ").concat(isEnableTabView ? "px-1" : "px-0"),
                                        children: !checkoutMode && !orderMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuantitySelector/* default */.Z, {
                                            size: "small",
                                            value: prodQuantity,
                                            onChange: handleChange,
                                            loading: qtyLoading || loading,
                                            productData: data,
                                            source: "cart-landing",
                                            isBundleParent: isBundleParent,
                                            productInfoData: JSON.parse(cartItemProductInfo)
                                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                            children: shouldRenderQuantity ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                className: "cart-item__label",
                                                "aria-description": i18n.quantity,
                                                children: [
                                                    isDeliveryOption || isAlert || orderMode ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "".concat(isAlert ? "hide-desktop-qty" : "", " --desktop"),
                                                        children: [
                                                            i18n.qty,
                                                            " :",
                                                            " "
                                                        ]
                                                    }) : null,
                                                    data.quantity
                                                ]
                                            }) : null
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                        children: [
                                            !isAlert && !isDeliveryOption && !orderMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "".concat(orderMode ? "col-6" : "col-6", "  cart-item__discount-container discount-container-padding"),
                                                children: !is3COrder && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "cart-item__price",
                                                            "aria-live": "assertive",
                                                            "aria-atomic": true,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "cart-item__total-price hide-mobile-price",
                                                                    "aria-description": i18n.unitPrice,
                                                                    value: (0,utils/* getDiscountPrice */.lk)(data === null || data === void 0 ? void 0 : data.discountPrice, data === null || data === void 0 ? void 0 : data.discountUnitPrice, data === null || data === void 0 ? void 0 : data.unitPrice),
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2,
                                                                    fixedDecimalScale: true
                                                                }),
                                                                (data === null || data === void 0 ? void 0 : (ref2 = data.brand) === null || ref2 === void 0 ? void 0 : ref2.toLowerCase()) === "annsacks" && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "hide-mobile-price",
                                                                    children: (0,utils/* getTmpType */.S)({
                                                                        category,
                                                                        i18n
                                                                    })
                                                                }),
                                                                (isDeliveryOption ? !comboChild : true) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "".concat(isDeliveryOption ? "col-6" : "col-2", " text-right cart-item__total px-0 mobile-total-price"),
                                                                    "aria-live": "assertive",
                                                                    "aria-atomic": true,
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                            className: "cart-item__total-price ",
                                                                            "aria-label": "".concat(i18n.total, " ").concat(i18n.itemPrice),
                                                                            value: data.totalPrice,
                                                                            displayType: "text",
                                                                            thousandSeparator: true,
                                                                            prefix: currencySign,
                                                                            decimalScale: 2,
                                                                            fixedDecimalScale: true
                                                                        }),
                                                                        " "
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {
                                                                    className: "show-mobile"
                                                                }),
                                                                data.discountPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "cart-item__span car-total-qty-desktop",
                                                                    value: Number(data === null || data === void 0 ? void 0 : data.discountUnitPrice) ? data === null || data === void 0 ? void 0 : data.discountUnitPrice : unitPrice,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2
                                                                }),
                                                                (data === null || data === void 0 ? void 0 : (ref3 = data.brand) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase()) === "annsacks" && (data === null || data === void 0 ? void 0 : data.discountPrice) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    className: "cart-item__span hide-mobile-price",
                                                                    children: (0,utils/* getTmpType */.S)()
                                                                }),
                                                                data.discountPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                    className: "cart-item__span car-total-qty-mobile",
                                                                    value: data.unitPrice * quantity,
                                                                    displayType: "text",
                                                                    thousandSeparator: true,
                                                                    prefix: currencySign,
                                                                    decimalScale: 2
                                                                })
                                                            ]
                                                        }),
                                                        !orderMode && data.discountPrice > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: orderMode ? "cart-item__display-discount-order" : !checkoutMode ? "cart-item__display-discount-cart" : "cart-item__display-discount",
                                                            "aria-label": "Striked price",
                                                            "aria-required": "true",
                                                            "aria-invalid": "false",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: orderMode ? "cart-item__discount-price --offPercentage" : !checkoutMode ? "cart-item__discount-price --offPercentCart" : "cart-item__discount-price --offPercent",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: data.discountPercent ? "".concat(data.discountPercent).concat(i18n.discountPercentage) : data.discountAmount ? "".concat(currencySign).concat(discountVal, " ").concat(i18n.off) : ""
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }) : null,
                                            shouldRenderPrice ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "".concat(isDeliveryOption || isAlert || orderMode ? "col-6" : "col-2", " text-right cart-item__total px-0 hide-price-popup-mobile"),
                                                "aria-live": "assertive",
                                                "aria-atomic": true,
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                        className: "cart-item__total-price hide-mobile-price",
                                                        "aria-label": "".concat(i18n.total, " ").concat(i18n.itemPrice),
                                                        value: data.totalPrice,
                                                        displayType: "text",
                                                        thousandSeparator: true,
                                                        prefix: currencySign,
                                                        decimalScale: 2,
                                                        fixedDecimalScale: true
                                                    }),
                                                    isDeliveryOption && data.discountPrice > 0 || orderMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "cart-item__display-discount",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "cart-item__discount-price",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_number_format_es/* NumericFormat */.h3, {
                                                                value: data.unitPrice * data.quantity,
                                                                displayType: "text",
                                                                thousandSeparator: true,
                                                                prefix: currencySign,
                                                                decimalScale: 2,
                                                                fixedDecimalScale: true
                                                            })
                                                        })
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "clear"
                                    })
                                ]
                            }),
                            shouldRenderTrackingButtons(data.trackingLinks, data.svgId, isEnableTabView) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: isEnableTabView ? "tracking-links-wrapper" : "cart-item__links",
                                children: [
                                    (ref4 = data.trackingLinks) === null || ref4 === void 0 ? void 0 : ref4.map((link, i)=>{
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(react.Fragment, {
                                            children: data.availableQty || isEnableTabView ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "cart-item__link cart-item__track-btn ".concat(isEnableTabView ? "cart-item__link-tabs-enabled " : ""),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        href: link.trackingURL,
                                                        target: "_blank",
                                                        rel: "noopener noreferrer",
                                                        className: trackingLinkAnalyticsData ? "gbh-data-layer" : "",
                                                        "data-gbh-data-layer": trackingLinkAnalyticsData ? (0,analytics/* getTrackingLinkAnalyticsData */.D_)(link.trackingURL, trackingLinkAnalyticsData, isEnableTabView, activeTab) : null,
                                                        "data-gbh-data-layer-custom": cartItemProductInfo,
                                                        children: i18n.tracking
                                                    }),
                                                    isEnableTabView && link.shipmentDate ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                        className: "cart-item__delivery-date",
                                                        children: [
                                                            i18n.shipmentDate,
                                                            " ",
                                                            (0,dateHelper/* formatDate */.p6)((0,dateHelper/* parseDate */.sG)(link.shipmentDate), "MM/dd/yy")
                                                        ]
                                                    }) : null
                                                ]
                                            }, i) : null
                                        }, link.trackingId);
                                    }),
                                    data.svgId && !orderMode && !isAsProduct && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item__link",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: linkAnalyticsData ? "gbh-data-layer" : "",
                                            role: "link",
                                            tabIndex: "0",
                                            "data-gbh-data-layer": linkAnalyticsData || null,
                                            "data-gbh-data-layer-custom": cartItemProductInfo,
                                            onClick: ()=>setPartsModal(true),
                                            children: i18n.viewPartsDiagram
                                        })
                                    })
                                ]
                            }) : null,
                            showRadio && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "cart-item__radio-group",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                    value: "remove",
                                    checked: action === "remove",
                                    type: "black",
                                    label: i18n.remove,
                                    name: "kf-shipping-alert-".concat(data.sku),
                                    onSelect: (e)=>setAction(e.target.value)
                                })
                            })
                        ]
                    }) : null,
                    isMsgStatus && !orderMode ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "".concat(orderMode && email ? "order-mode-hide-main-section" : "col-12"),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "cart-item__cta-wrapper hide-mobile-checkout-section",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "cart-blank-section",
                                    children: "\xa0"
                                }),
                                !checkoutMode && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "remove-sec-cart",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "cart-item__cta ".concat(loading ? "--loading" : ""),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            tabIndex: "0",
                                            role: "button",
                                            "aria-label": "".concat(data.name, " ").concat(i18n.remove),
                                            onClick: handleRemoveItem,
                                            children: "Remove"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "clear"
                                })
                            ]
                        })
                    }) : null
                ]
            })
        ]
    });
};
/* harmony default export */ var cart_CartItemTile = (CartItemTile);


/***/ }),

/***/ 87223:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"PreviewCartBundleSection":"BundlesViewDetails_PreviewCartBundleSection__8OioI"};

/***/ })

}]);